import React, { FunctionComponent, useCallback, useState } from 'react';
import { useStore } from 'effector-react';

import IUser from '@interfaces/IUser';
import chatClaims, {
  getList as getChatClaims,
  reset as resetChatClaims,
} from '@stores/chat-claims';
import ChatClaims from '@components/SpamUserCard/ChatClaims/ChatClaims';

interface UserChatClaimsTriggerProps {
  user?: IUser | null;
}

const UserChatClaimsTrigger: FunctionComponent<UserChatClaimsTriggerProps> = ({ user }) => {
  const { preloaders } = useStore(chatClaims);
  const [chatClaimsTable, setChatClaimsTable] = useState<any[]>([]);

  const handleChatClaimsOpen = useCallback(
    (value: boolean) => {
      if (!value || !user?.id) return;

      resetChatClaims();
      getChatClaims(user.id).then(({ data }) => {
        setChatClaimsTable(data?.body?.result?.page || []);
      });
    },
    [user?.id],
  );

  return (
    <ChatClaims
      chatClaimsTable={chatClaimsTable}
      isLoading={!!preloaders.getList}
      onOpen={handleChatClaimsOpen}
      user={user}
    />
  );
};

export default UserChatClaimsTrigger;
